import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import './ComprehensiveMetricsDisplay.css' 

ChartJS.register(ArcElement, Tooltip);
function ComprehensiveMetricsDisplay({ comprehensiveMetrics, configStatuses }) {
    console.log("comp")
    console.log(comprehensiveMetrics)
    const totalEntries = comprehensiveMetrics?.metrics?.["Number of Entries"] || 1;
    const matchedAmount = comprehensiveMetrics?.metrics?.["Matched Amount"] || 0;
    const unmatchedAmount = comprehensiveMetrics?.metrics?.["Unmatched Amount"] || 0;


    const unresolvedAmount = comprehensiveMetrics?.metrics?.["Unresolved"] || 0;
    const inprogressAmount = comprehensiveMetrics?.metrics?.["In-Progress"] || 0;
    const resolvedAmount = comprehensiveMetrics?.metrics?.["Resolved"] || 0;

    const calculateStatusCounts = () => {
        const counts = {};
        Object.values(configStatuses).forEach(status => {
            counts[status] = (counts[status] || 0) + 1;
        });
        return counts;
    };

    const statusCounts = calculateStatusCounts();

    const getValueOfBreaksByCategory = (categories) => comprehensiveMetrics?.break_counts?.reduce((total, item) => {
        const columnName = item.column_name.toLowerCase();
        if (categories.some(category => columnName.includes(category.toLowerCase()))) {
            return total + parseFloat(item['value of breaks'] || 0);
        }
        return total;
    }, 0) || 0;
    
    // Modify valueOfPriceBreaks to include multiple terms
    const valueOfPriceBreaks = getValueOfBreaksByCategory(['price', 'amount', 'shareprice', 'averageprice']);
    
    // Pass an array for `valueOfMatchedPrice` as well, even if it contains only one item
    const valueOfMatchedPrice = getValueOfBreaksByCategory(['matched_df']);
    
   

    const matchedChartData = {
        labels: ['Matched', 'Unmatched'],
        datasets: [{
            data: [matchedAmount + resolvedAmount, unresolvedAmount + inprogressAmount], // Use actual amounts
            backgroundColor: ['#4caf50', '#ff4d4d'],
        }],
    };

    const matchedChartOptions = {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '75%',
        plugins: {
          datalabels: {
            display: true,
            color: 'white',
            formatter: (value) => value > 0 ? value : null,
          }
        }
      };

      const statusColors = {
        'To Review': '#ff4d4d', // Red for "To Review", indicating urgent attention is needed
        'Files Present': '#80808a', // Yellow for "Files Present", indicating caution or to denote presence
        'Files Missing': '#d3d3d3', // Gray for "Files Missing", suggesting neutrality or absence
        'Recon Successful': '#4caf50' // Green for "Reconciled", symbolizing completion and success
    };
    

    const statusChartData = {
        labels: Object.keys(statusCounts),
        datasets: [{
            data: Object.values(statusCounts),
            backgroundColor: Object.keys(statusCounts).map(status => statusColors[status] || '#999999'),
        }],
    };

    const statusChartOptions = {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '75%',
        plugins: {
          datalabels: {
            display: true,
            color: 'white',
            formatter: (value) => value > 0 ? value : null,
          }
        }
      };

        // Styling for chart and status display, assuming use of similar styles as ReconciliationMetricsDisplay
        const chartStyle = {
            width: '120px',
            height: '120px'
        };

        const currentBreaksChartData = {
            labels: ['Unresolved', 'In-Progress', 'Resolved'],
            datasets: [{
                data: [unresolvedAmount, inprogressAmount, resolvedAmount],
                backgroundColor: ['#ff4d4d', '#ffcc00', '#4caf50'],
            }],
        };
    
        const currentBreaksChartOptions = {
            responsive: true,
            maintainAspectRatio: true,
            cutout: '75%',
        };


        return (
            <div className="comprehensive-metrics-display">
            {/* Matched Chart Display with Data Labels on the Right */}
            <div className="metric-column">
                <h3 className="metric-title">Matched</h3>
                <div className="chart-and-stats">
                    <div className="metric-content" style={chartStyle}>
                        <Doughnut data={matchedChartData} options={matchedChartOptions} />
                    </div>
                    <div className="chart-stats" style={{ marginLeft: 'auto' }}>
                    {matchedAmount > 0 && <p>Matched: {matchedAmount + resolvedAmount}</p>}
                    {unmatchedAmount > 0 && <p>Unmatched: {unresolvedAmount + inprogressAmount}</p>}
                    </div>
                </div>
            </div>
        
      {/* Today's Breaks */}
<div className="metric-column">
    <h3 className="metric-title">Current Breaks</h3>
    <div className="chart-and-stats">
        {/* Chart on the left */}
        <div className="metric-content" style={chartStyle}>
            <Doughnut data={currentBreaksChartData} options={currentBreaksChartOptions} />
        </div>
        {/* Data labels on the right */}
        <div className="chart-stats" style={{ marginLeft: 'auto' }}>
            {unresolvedAmount > 0 && <p>Unresolved: {unresolvedAmount}</p>}
            {inprogressAmount > 0 && <p>In-Progress: {inprogressAmount}</p>}
            {resolvedAmount > 0 && <p>Resolved: {resolvedAmount}</p>}
        </div>
    </div>
</div>

        
                {/* Value of Specific Breaks Display */}
                <div className="metric-column">
                    <h3 className="metric-title">Value of Current Breaks</h3>
                    <div className="metric-content">
                    {valueOfPriceBreaks > 0 && <p style={{ fontSize: '1.25em', fontWeight: 'normal' }}>${valueOfPriceBreaks.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>}
                    </div>
                </div>

                                {/* Total Value Reconciled  */}
                                <div className="metric-column">
                    <h3 className="metric-title">Total Value Reconciled</h3>
                    <div className="metric-content">
                    {valueOfMatchedPrice > 0 && <p style={{ fontSize: '1.25em', fontWeight: 'normal' }}>${valueOfMatchedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>}
                    </div>
                </div>
               
        
        
        
   {/* Status of Reconciliations with Chart on the Right and Data on the Left */}
   <div className="metric-column">
            <h3 className="metric-title">Status of Reconciliations</h3>
            <div className="chart-and-stats">
                <div className="chart-stats" style={{ marginRight: '20px' }}>
                    {Object.entries(statusCounts).map(([status, count]) => (
                        <p key={status}>{status}: {count}</p>
                    ))}
                </div>
                {/* Chart */}
                <div className="metric-content" style={{ marginLeft: 'auto', ...chartStyle }}>
                    <Doughnut data={statusChartData} options={statusChartOptions} />
                </div>
            </div>
        </div>
    </div>







);
}
export default ComprehensiveMetricsDisplay;

